/**
 * La résiliation de l'entreprise, si le staff en a posé une.
 *
 * Relue toutes les dix minutes : la lecture seule commence à minuit, et un
 * onglet resté ouvert doit le dire sans attendre un rechargement.
 */
import { useQuery } from "@tanstack/react-query";
import { terminationState } from "@dker/core";
import { serviceDeps, terminationServices, useExecutionContext } from "@/services";
import { useAuthStore } from "@/stores/authStore";
import { jourLocal } from "@/lib/utils";

export function useTenantTermination() {
  const makeContext = useExecutionContext();
  const tenantId = useAuthStore((s) => s.tenant?.id);

  const query = useQuery({
    queryKey: ["tenant-termination", tenantId],
    enabled: !!tenantId,
    staleTime: 10 * 60 * 1000,
    refetchInterval: 10 * 60 * 1000,
    queryFn: () => terminationServices.lireResiliation(makeContext(), {}, serviceDeps),
  });

  return terminationState(query.data ?? null, jourLocal());
}
